import type { IAuthenticationStep } from '@signing-page/authentication/types/authentication-step';
import type { EAuthenticationStepType } from '@signing-page/authentication/types/enums/authentication-step-type';

export class AuthenticationHelper {
  public static declinedConsent(
    authSteps: IAuthenticationStep[],
    type: EAuthenticationStepType
  ): boolean {
    const gdprInput: boolean = authSteps.some((step: IAuthenticationStep) => step.type === type);
    return gdprInput;
  }
}
